import React from 'react'
import { TextBoxAreaProps, TextBoxAreaState } from './interface'
import { Counter, TextAreaBox } from './style'

class TextBoxArea extends React.Component<TextBoxAreaProps, TextBoxAreaState> {
  state = {
    charLimitExceeds: false,
  }

  componentDidUpdate(prevProps: Readonly<TextBoxAreaProps>): void {
    const { value, maxlength } = this.props
    if (prevProps.value !== value) {
      this.setState({
        charLimitExceeds: value.length > maxlength,
      })
    }
  }

  render() {
    const { children, maxlength, value, textBoxError } = this.props
    const charLimitExceeds = value.length > maxlength
    return (
      <TextAreaBox error={charLimitExceeds || textBoxError}>
        {children}
        <Counter error={charLimitExceeds}>{maxlength - value.length}</Counter>
      </TextAreaBox>
    )
  }
}

export default TextBoxArea
